import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';
import { parseHtml } from '@grandvisionhq/utils';

const StoreDescription = (_param)=>{
    var { className , labels , description  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "description"
    ]);
    return description ? /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-description', className)
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, labels.title), parseHtml(description)) : null;
};
var StoreDescription$1 = StoreDescription;

export { StoreDescription$1 as default };
//# sourceMappingURL=StoreDescription.js.map
